import { useContext } from 'react';
import { SmartContext } from '../../../../library/Core/SmartContext';
import InstituteWiseBenefitsLayout from './InstituteWiseBenefitsLayout';
import { getDomainValueForCode } from '../../../../library/Core/SmartFunctions';

const BenefitsLayout = (props: any) => {
    const { state, dispatch } = useContext(SmartContext);
    const instituteId = state?.data?.selectedInstitute?.instituteId || null;
    const id = state?.data?.id;
    const firstName = state?.data?.firstName || 'Alumni';
    const instituteName = getDomainValueForCode(instituteId, 'INSTITUTE_DOMAIN', state) || 'Institute Name';
    
    return (
        <>
            <div className="main-wrap">
                
                    <div className="bg_congratulations w-100 py-3">
                        <div className="max-1140 py-4 overflow-hidden mx-auto">
                            <h2 className="font-22 font-600 text-white mb-2">Congratulations, {firstName}</h2>
                            <p className="font-18 font-400 text-white mb-0">You have unlocked the exclusive alumni benefits of {instituteName} Alumni Network.</p>
                        </div>
                    </div>


                    <div className="max-1140 pt-3 pt-sm-4 px-lg-0 pb-5 overflow-hidden mx-auto">
                        <div className='row g-3'>
                            <SmartContext.Provider value={{ state, dispatch }}>
                                {state?.data?.userInstitutes && instituteId && <InstituteWiseBenefitsLayout instituteId={instituteId} showInstituteName={false} />}
                            </SmartContext.Provider>
                        </div>
                        
                    </div>
                    
                    <div className="max-1140 overflow-hidden mx-auto">
                        <div className="border-radius-6">
                            <div className="pb-5 overflow-hidden mx-auto">
                                <button className="btn-green mx-auto height-45 mt-2" 
                                onClick={() => {state.actions['ROUTER_NAVIGATE'](`/alumni/${id}/profile`)}}
                                >
                                    <span>Go to Profile</span>
                                </button>
                            </div>
                        </div>
                    </div>

              
            </div>
        </>
    );
};

export default BenefitsLayout;
